module.exports = __webpack_public_path__ + "static/img/uiam-lake-sightseeing-cruise.8fa21ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/uiam-lake-sightseeing-cruise.jpg
// module id = Q3bi
// module chunks = 0